const addCama = (value) =>{
  const result = value.toString().replace(/\D/g, "")
  .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return result;
}


export default addCama;
